import * as React from 'react';
import type { SVGProps } from 'react';

const SvgXMark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" {...props}>
    <path d="m17.6 15.64 8.45-8.44c.42-.42.42-1.09 0-1.51-.42-.42-1.09-.42-1.51 0l-8.44 8.45-8.45-8.45c-.42-.42-1.09-.42-1.51 0-.42.42-.42 1.09 0 1.51l8.45 8.44-8.28 8.28c-.42.42-.42 1.09 0 1.51.42.42 1.09.42 1.51 0l8.27-8.28 8.28 8.28c.42.42 1.09.42 1.51 0 .42-.42.42-1.09 0-1.51l-8.28-8.27v-.01Z" />
  </svg>
);

export default SvgXMark;
